export const reverseGeocode = async (lat, lon) => {
  if (!lat || !lon) {
    return "Location not available";
  }

  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=18&addressdetails=1`
    );
    const data = await response.json();

    if (data?.display_name) {
      return data.display_name;
    } else {
      return "Unknown location";
    }
  } catch (error) {
    console.error("Reverse geocoding error:", error);
    return "Failed to fetch location name";
  }
};